import { types } from './constants';

export const INITIAL_STATE = {
  epgData: {
    errors: null,
    isLoading: false,
    items: []
  },
  selectedDay: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.EPG_DATA_FETCH:
      return {
        ...state,
        epgData: {
          ...state.epgData,
          errors: null,
          isLoading: true
        }
      };
    case types.EPG_DATA_FETCH_FAILURE:
      return {
        ...state,
        epgData: {
          errors: action.errors,
          isLoading: false,
          items: []
        }
      };
    case types.EPG_DATA_FETCH_SUCCESS:
      return {
        ...state,
        epgData: {
          errors: null,
          isLoading: false,
          items: action.epgDataItems
        }
      };
    case types.SELECTED_DAY_CHANGED:
      return {
        ...state,
        selectedDay: action.selectedDay
      };
    default:
      return state;
  }
};

export default reducer;
